<template>
  <ThemeProvider color="dark">
    <div class="account-home-nav">
      <nuxt-link to="/" class="account-home-nav__label">{{ $t('NAV_HOME_LABEL') }}</nuxt-link>
      <nuxt-link v-if="hasProfile" :to="profileLink">
        <ProfileImage
          :imageUrl="profile.imageUrl"
          :altText="$t('ALT_MORE_PROFILE_IMAGE')"
          :aria-label="$t('ALT_MORE_PROFILE_IMAGE')"
        >
          <ShIcon
            role="button"
            aria-label="profile-image"
            tabindex="0"
            size="large"
            name="human"
            :invert="true"
          />
        </ProfileImage>
      </nuxt-link>
    </div>
    <div class="account-outer">
      <div class="account-inner">
        <slot />
      </div>
      <sh-footer tabindex="-1"/>
    </div>
  </ThemeProvider>
</template>

<script>
import { ThemeProvider, ShIcon, ProfileImage } from '@sohohouse/design-system'
import { createNamespacedHelpers } from 'vuex'

import isEmptyObject from '~/helpers/is-empty-object'
import ShFooter from '~/components/sh-footer'

const { mapGetters: mapProfileGetters } = createNamespacedHelpers('user/profile')

export default {
  components: {
    ThemeProvider,
    ShFooter,
    ShIcon,
    ProfileImage
  },

  computed: {
    ...mapProfileGetters(['profile']),
    profileLink () {
      return this.localePath('settings-preferences')
    },

    hasProfile () {
      return this.profile && !isEmptyObject(this.profile)
    }
  }
}
</script>

<style lang="scss" scoped>
.account-home-nav {
  display: flex;
  justify-content: space-between;
  background-color: $color-black;
  padding: $space-060 $space-060 0;

  &__label {
    text-transform: uppercase;
    color: $color-white;
    @include font('070')
  }
}

.account-outer {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-height: 100vh;
  height: 100%;
  position: relative;
  background-color: $color-black;
}

.account-inner {
  width: 90%;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: $space-060 0;

  @include tablet {
    width: 50%;
  }
}
</style>
